/* MYTOUCHI-LIGHT:START · 2026-10-20 · pohyb pro světlou verzi
   Rollback: smazat tento soubor + mytouchi-light.css + blok v meta-tags.liquid */
(function () {
  'use strict';
  var doc = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHeader() {
    var header = document.querySelector('sticky-header.header-wrapper');
    if (!header) return;
    var on = false;
    function update() {
      var next = window.scrollY > 8;
      if (next !== on) { on = next; header.classList.toggle('mtl-scrolled', on); }
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initFocus() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var sel = ['.mts-section h2', '.mts-dark h2', '.mts-final h2', '.mts-hero h1',
      '.mm-story h2', '.mac-promo h2', '.mps h2', '.mts-product h3'].join(',');
    var items = Array.prototype.slice.call(document.querySelectorAll(sel)).filter(function (el) {
      return !el.closest('.mm-stage, .mac-device, .mm-demo');
    });
    if (!items.length) return;
    doc.classList.add('mtl-motion');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mtl-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });
    items.forEach(function (el, i) {
      var r = el.getBoundingClientRect();
      el.classList.add('mtl-focus');
      if (el.matches('.mts-product h3')) el.style.setProperty('--mtl-delay', (i % 3) * 0.08 + 's');
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) {
        requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('mtl-in'); }); });
      } else {
        io.observe(el);
      }
    });
    setTimeout(function () { items.forEach(function (el) { el.classList.add('mtl-in'); }); }, 6000);
  }

  function initSpotlight() {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    var cards = document.querySelectorAll('.mts-dark .mts-tech, .mps-spec-grid article, #mts-models .mts-product');
    Array.prototype.forEach.call(cards, function (card) {
      card.addEventListener('pointermove', function (ev) {
        var r = card.getBoundingClientRect();
        card.style.setProperty('--mx', (ev.clientX - r.left) + 'px');
        card.style.setProperty('--my', (ev.clientY - r.top) + 'px');
      }, { passive: true });
    });
  }

  function initParallax() {
    if (reduce) return;
    var media = document.querySelectorAll('.mps-scene__media, .mm-inspect-frame');
    if (!media.length) return;
    var ticking = false;
    function frame() {
      ticking = false;
      var vh = window.innerHeight;
      Array.prototype.forEach.call(media, function (m) {
        var r = m.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height) * 1.6));
        m.style.setProperty('--mtl-p', p.toFixed(3));
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
    frame();
  }

  function initCounters() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('.mts-big-number, .mps-spec-grid strong');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, orig = el.textContent, m = orig.match(/^(\s*)(\d{1,4})(.*)$/);
        if (!m || el.children.length) return;
        var target = parseInt(m[2], 10), t0 = performance.now(), dur = 1100;
        (function step(now) {
          var k = Math.min(1, (now - t0) / dur), eased = 1 - Math.pow(1 - k, 4);
          el.textContent = m[1] + Math.round(target * eased) + m[3];
          if (k < 1) requestAnimationFrame(step); else el.textContent = orig;
        })(t0);
      });
    }, { threshold: 0.6 });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  function init() { initHeader(); initFocus(); initSpotlight(); initParallax(); initCounters(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
/* MYTOUCHI-LIGHT:END */